import { render, staticRenderFns } from "./FilterByProduct.vue?vue&type=template&id=97846ba4"
import script from "./FilterByProduct.vue?vue&type=script&lang=js"
export * from "./FilterByProduct.vue?vue&type=script&lang=js"
import style0 from "./FilterByProduct.vue?vue&type=style&index=0&id=97846ba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports